// src/reduxStore/accessLogs/slice.js
import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const defaultFilters = {
	page: 1,
	pageSize: 10,
	personIDs: [],
	deviceIDs: [],
	status: undefined,
	dateFrom: dayjs().subtract(1, 'month').startOf('day').toISOString(),
	dateTo: dayjs().endOf('day').toISOString(),
	integrationID: undefined,
	siteID: undefined
};

const initialState = {
	data: {}, // { [orgID]: [ ...logs ] }
	totals: {}, // { [orgID]: number }
	filters: {}, // { [orgID]: { page, pageSize, ... } }
	loading: false,
	syncing: false,
	error: null,
	timeStamp: null,
	completeLogsData: false
};

const accessLogsSlice = createSlice({
	name: 'accessLogs',
	initialState,
	reducers: {
		loadAccessLogs(state, action) {
			const orgID = action?.payload?.orgID;
			state.loading = true;
			state.error = null;
			// Initialize filters with defaults if not set for this org
			if (orgID && !state.filters[orgID]) {
				state.filters[orgID] = { ...defaultFilters };
			}
		},
		setAccessLogsFilters(state, action) {
			const { orgID, filters, resetPage = true } = action.payload;
			const current = state.filters[orgID] || defaultFilters;
			state.filters[orgID] = {
				...current,
				...filters,
				...(resetPage && !('page' in filters) ? { page: 1 } : {})
			};
		},
		resetAccessLogsFilters(state, action) {
			const { orgID } = action.payload;
			state.filters[orgID] = { ...defaultFilters };
		},
		loadAccessLogsSuccess(state, action) {
			const { orgID, data, total } = action.payload;
			state.data[orgID] = data;
			state.totals[orgID] = total;
			state.loading = false;
			state.syncing = false;
			state.timeStamp = Date.now();
			state.completeLogsData = true;
		},
		loadAccessLogsError(state, action) {
			state.loading = false;
			state.syncing = false;
			state.error = action.payload;
		}
	}
});

export const accessLogsActions = accessLogsSlice.actions;
export default accessLogsSlice.reducer;
